import './ThemeLayout.css'
import React from 'react'
import BackHome from 'components/back-home'
import NETImage from "components/net-image"

/**
 * 课程主题页布局
 */
export default function ThemeLayout({
    theme,
    header = '',
    footer = '',
    children,
}) {
    return (
        <section className='theme__layout'>
            <NETImage                
                prefix={theme}
                src={header}
                useAutoHeight
            />
            <div className='theme__layout-main'>
                {children}
            </div>
            <NETImage
                useAutoHeight
                prefix={theme}
                src={footer}
                startHeight={64}
            />
            <BackHome theme={theme} />
        </section>
    )
}